import { useRef, useState } from "react";

const useRequestLock = () => {
  const locks = useRef({});
  const [loading, setLoading] = useState({});

  const execute = async (key, callback) => {
    if (locks.current[key]) {
      return;
    }

    locks.current[key] = true;

    setLoading(prev => ({
      ...prev,
      [key]: true,
    }));

    try {
      return await callback();
    } finally {
      locks.current[key] = false;

      setLoading(prev => ({
        ...prev,
        [key]: false,
      }));
    }
  };

  return {
    loading,
    execute,
  };
};

export default useRequestLock;